module.exports = __webpack_public_path__ + "img/reestrator.c2b73485.jpg";